import { Translation } from '@ps/web-shared-components';
import classNames from 'clsx';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import ToggleArrow from '@swf/core/assets/icons/arrow.svg';
import type { Dispatch } from '@swf/core/store';
import { CheckmarkIcon } from '@swf/poker';

import { usePokerMultiTableTournamentsWidget } from '../../../model';
import { ModalRoutes } from '../../../types';
import { hasAnyActiveUiFilters } from '../../../utils/filters';

import type { SortByDropdownProps } from './SortByDropdown/SortByDropdown';
import SortByDropdown from './SortByDropdown/SortByDropdown';
import { TXTCLI_Filters, TXTCLI_Sort_by } from './SortFilterContainer.messages.json';
import styles from './SortFilterContainer.scss';

const SortFilterContainer: React.FC = () => {
  const { modal } = useDispatch<Dispatch>();
  const { widgetId, widgetSelect, widgetDispatch } = usePokerMultiTableTournamentsWidget();
  const activeUiFilters = useSelector(widgetSelect.getActiveUiFilters);
  const [sortByOpened, setSortByOpened] = useState(false);
  const hasActiveUiFilters = hasAnyActiveUiFilters(activeUiFilters);

  const handleFiltersClick = () =>
    modal.enqueue({
      path: ModalRoutes.MobileFiltersScreen,
      locationState: { widgetId }
    });

  const handleSortByClick = () => setSortByOpened((prev) => !prev);

  const handleOptionSelect: SortByDropdownProps['onOptionSelect'] = (payload) => {
    widgetDispatch.setTableSortRule(payload);
    setSortByOpened(false);
  };

  const handleCloseSortBy = () => setSortByOpened(false);

  return (
    <div className={styles.sortFilterContainer}>
      <div className={classNames(styles.section, styles.sortBy)} onClick={handleSortByClick}>
        <Translation {...TXTCLI_Sort_by} />
        <ToggleArrow
          className={classNames(styles.arrow, { [styles.upwardsArrow]: sortByOpened })}
        />
      </div>
      <SortByDropdown
        show={sortByOpened}
        onOptionSelect={handleOptionSelect}
        onClose={handleCloseSortBy}
      />
      <div
        className={classNames(styles.section, {
          [styles.checked]: hasActiveUiFilters
        })}
        onClick={handleFiltersClick}
      >
        <Translation {...TXTCLI_Filters} />
        {hasActiveUiFilters && <CheckmarkIcon className={styles.icon} />}
      </div>
    </div>
  );
};

export default SortFilterContainer;
